import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, apiAuth } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AuthCallback(){
  const nav = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(()=>{
    if (done.current) return; done.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/"); return; }
    (async ()=>{
      try {
        await apiAuth.post("/auth/google/session", { session_id: m[1] });
        await refresh();
        nav("/customer", { replace: true });
      } catch(e) { nav("/login", { replace: true }); }
    })();
    // `nav` and `refresh` are stable React Router / context callbacks; the
    // useRef `done` guard ensures this effect only runs once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  return <div className="min-h-screen flex items-center justify-center bg-[#FFF8EE]">Signing you in…</div>;
}
